<template>
  <div>
    <!--单选下拉-->
    <el-select
      filterable
      clearable
      v-model="value"
      :placeholder="'请选择' + config.cnName"
      v-if="type == 'radio'"
    >
      <el-option
        v-for="item in config.rules.selectConfig.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <!--多选下拉-->
    <el-select
      filterable
      multiple
      clearable
      v-model="value"
      :placeholder="'请选择' + config.cnName"
      v-else-if="type == 'multi'"
    >
      <el-option
        v-for="item in config.rules.selectConfig.options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>
<script>
export default {
  props: ["data", "config"],
  computed: {
    type() {
      if (this.config.rules.selectConfig.type.indexOf("multi") > -1) {
        return "multi";
      } else {
        return "radio";
      }
    },
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
};
</script>
